import {
    Caption,
    Paragraph,
    useAppDisplayModeContext,
    useStyles,
} from '@archipro-design/aria';
import * as S from './ContactPage.desktop.style';

const NO_RESULT_TEXT =
    'No locations match your search. Please try different keywords.';

export const NoSearchResult: React.FC = () => {
    const { css } = useStyles();
    const { mobile: isMobile } = useAppDisplayModeContext();

    return (
        <div className={css(S.NoSearchResult)}>
            {isMobile ? (
                <Caption variant="03">{NO_RESULT_TEXT}</Caption>
            ) : (
                <Paragraph>{NO_RESULT_TEXT}</Paragraph>
            )}
        </div>
    );
};
